(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("6SwLG", function(module, exports) {

$parcel$export(module.exports, "Context", function () { return $502134446644a9ce$export$841858b892ce1f4c; });
$parcel$export(module.exports, "make", function () { return $502134446644a9ce$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $2Ng4w = parcelRequire("2Ng4w");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $3tS2g = parcelRequire("3tS2g");

var $3QSSt = parcelRequire("3QSSt");

var $gCzsf = parcelRequire("gCzsf");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $4Q2zg = parcelRequire("4Q2zg");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $jQE31 = parcelRequire("jQE31");

var $gUsPc = parcelRequire("gUsPc");
var $502134446644a9ce$export$5e725b8338a85d51 = function getTouchY(e) {
    return e.touches ? e.touches[0].pageY : 0;
};
var $502134446644a9ce$export$66e76ce6d60c3fb = function getTouchY(e) {
    return e.touches ? e.touches[0].clientX : 0;
};
var $502134446644a9ce$var$context = /*#__PURE__*/ $g85JO.createContext({
    needsShadow: true,
    setNeedsShadow: function setNeedsShadow(value) {}
});
var $502134446644a9ce$var$provider = $502134446644a9ce$var$context.Provider;
function $502134446644a9ce$var$Drawer$Context$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($502134446644a9ce$var$provider, {
        value: value,
        children: children
    });
}
$502134446644a9ce$var$Drawer$Context$Provider.displayName = "Drawer.Context.Provider";
var $502134446644a9ce$var$Provider = {
    provider: $502134446644a9ce$var$provider,
    make: $502134446644a9ce$var$Drawer$Context$Provider
};
function $502134446644a9ce$var$use(param) {
    return $g85JO.useContext($502134446644a9ce$var$context);
}
var $502134446644a9ce$export$841858b892ce1f4c = {
    context: $502134446644a9ce$var$context,
    Provider: $502134446644a9ce$var$Provider,
    use: $502134446644a9ce$var$use
};
function $502134446644a9ce$var$Drawer(Props) {
    var children = Props.children;
    var isOpenOpt = Props.isOpen;
    var scrollRef = Props.scrollRef;
    var scrollRef2 = Props.scrollRef2;
    var classNameOpt = Props.className;
    var onChangeState = Props.onChangeState;
    var onOpening = Props.onOpening;
    var onOpenOpt = Props.onOpen;
    var showOpt = Props.show;
    var showDragIndicatorOpt = Props.showDragIndicator;
    var fwdRef = Props.fwdRef;
    var onScrollLockOpt = Props.onScrollLock;
    var isOpen = isOpenOpt !== undefined ? isOpenOpt : false;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var onOpen = onOpenOpt !== undefined ? onOpenOpt : function onOpen(param) {};
    var show = showOpt !== undefined ? showOpt : true;
    var showDragIndicator = showDragIndicatorOpt !== undefined ? showDragIndicatorOpt : true;
    var onScrollLock = onScrollLockOpt !== undefined ? onScrollLockOpt : function onScrollLock(param) {};
    var match = $jQE31.Context.use(undefined);
    var match$1 = $9pMGg.use(undefined);
    var trackEvent = match$1.trackEvent;
    var match$2 = $aSJcu.use(undefined);
    var windowHeight = match$2.windowSize.height;
    var isMobile = match$2.isMobile;
    var topMargin = $gUsPc.useLenient(undefined);
    var match$3 = $hBcYV.useRouter(undefined);
    var didEdgeSwipe = $4Q2zg.useEdgeSwipeDetectorImmediate(undefined);
    var onOpening$1 = $2whNH.getWithDefault(onOpening, match$1.onDrawerOpening);
    var match$4 = $8E2YL.use(undefined);
    var settings = match$4.config.settings;
    var mobileDrawerHandleHeight = isMobile ? 14 : 0;
    var collapsedHeight = match.state.primaryNavbarHeight + mobileDrawerHandleHeight | 0;
    var match$5 = $g85JO.useState(function() {});
    var setDrag = match$5[1];
    var drag = match$5[0];
    var match$6 = $g85JO.useState(function() {
        return true;
    });
    var setNeedsShadow = match$6[1];
    var needsShadow = match$6[0];
    var setNeedsShadow$1 = function setNeedsShadow$1(value) {
        $iv6Yc._1(setNeedsShadow, function(param) {
            return value;
        });
    };
    var checkWillBeOpen = function checkWillBeOpen(y, dy) {
        if ($2Ng4w.abs(dy) < 20) return isOpen;
        else return dy < 0;
    };
    var openToY = function openToY(isOpen) {
        if (isOpen) return topMargin;
        else return windowHeight - collapsedHeight | 0;
    };
    var isScrollAtZero = function isScrollAtZero(ref) {
        return $2whNH.getWithDefault($2whNH.map($loT9g.nullable_to_opt(ref.current), function(el) {
            var scrollTop = el.scrollTop | 0;
            return scrollTop === 0;
        }), false);
    };
    var match$7 = settings.newMobilePDP;
    var isMobilePDP;
    if (isMobile && match$7) {
        var tmp = match$3.route;
        isMobilePDP = typeof tmp === "number" || tmp.TAG !== /* PDP */ 2 ? false : true;
    } else isMobilePDP = false;
    var isDragAllowed = function isDragAllowed(touchTarget) {
        var touchTargetIsScrollRef1 = $2whNH.getWithDefault($2whNH.map($loT9g.nullable_to_opt(scrollRef.current), function(el) {
            if ($7bjme.equal(el, touchTarget)) return true;
            else return $3tS2g.isDescendent(el, touchTarget);
        }), false);
        var touchTargetIsScrollRef2 = $2whNH.getWithDefault($2whNH.map(scrollRef2, function(ref) {
            return $2whNH.getWithDefault($2whNH.map($loT9g.nullable_to_opt(ref.current), function(el) {
                if ($7bjme.equal(el, touchTarget)) return true;
                else return $3tS2g.isDescendent(el, touchTarget);
            }), false);
        }), false);
        if (isMobilePDP) return false;
        else if (touchTargetIsScrollRef1) {
            if (isScrollAtZero(scrollRef) || !isOpen) return !didEdgeSwipe;
            else return false;
        } else if (touchTargetIsScrollRef2) {
            if (scrollRef2 !== undefined) {
                if (isScrollAtZero(scrollRef2) || !isOpen) return !didEdgeSwipe;
                else return false;
            } else return !didEdgeSwipe;
        } else return !didEdgeSwipe;
    };
    var lastTouchMoveY = $g85JO.useRef(0);
    var lastTouchMoveX = $g85JO.useRef(0);
    var isDragAllowedByAngleRef = $g85JO.useRef(undefined);
    var onTouchStart = function onTouchStart(e) {
        var pageX = $502134446644a9ce$export$66e76ce6d60c3fb(e);
        var pageY = $502134446644a9ce$export$5e725b8338a85d51(e);
        lastTouchMoveX.current = pageX;
        lastTouchMoveY.current = pageY;
        if (!isOpen) return $iv6Yc._1(onScrollLock, true);
    };
    var isDragAllowedByAngle = function isDragAllowedByAngle(e) {
        var pageX = $502134446644a9ce$export$66e76ce6d60c3fb(e);
        var pageY = $502134446644a9ce$export$5e725b8338a85d51(e);
        var diffX = pageX - lastTouchMoveX.current | 0;
        var diffY = pageY - lastTouchMoveY.current | 0;
        var isSignificantMovement = (Math.imul(diffX, diffX) + Math.imul(diffY, diffY) | 0) >= 25;
        var touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180.0 / Math.PI;
        var isGreaterThan45 = touchAngle > 45.0;
        var isDragAllowed = isSignificantMovement && isGreaterThan45;
        var match = isDragAllowedByAngleRef.current;
        if (match !== undefined) ;
        else isDragAllowedByAngleRef.current = isDragAllowed;
        return $2whNH.getWithDefault(isDragAllowedByAngleRef.current, isDragAllowed);
    };
    var onTouchMove = function onTouchMove(e) {
        var target = e.target;
        var drawerStartY = openToY(isOpen);
        var isDragAllowed$1 = isDragAllowedByAngle(e) && isDragAllowed(target);
        if (!isDragAllowed$1) return;
        var nextFingerY = $502134446644a9ce$export$5e725b8338a85d51(e);
        if (drag !== undefined) {
            var movement = drag.fingerStartY - nextFingerY | 0;
            return $iv6Yc._1(setDrag, function(param) {
                return {
                    drawerStartY: drag.drawerStartY,
                    drawerCurrentY: drag.drawerStartY - movement | 0,
                    fingerStartY: drag.fingerStartY,
                    fingerCurrentY: nextFingerY
                };
            });
        }
        $iv6Yc._1(setDrag, function(param) {
            return {
                drawerStartY: drawerStartY,
                drawerCurrentY: drawerStartY,
                fingerStartY: nextFingerY,
                fingerCurrentY: nextFingerY
            };
        });
        if (!isOpen) {
            $iv6Yc.app(trackEvent, [
                "swipe up drawer",
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            return $iv6Yc._1(onOpening$1, undefined);
        }
    };
    var onTouchEnd = function onTouchEnd(e) {
        isDragAllowedByAngleRef.current = undefined;
        if (!isOpen) $iv6Yc._1(onScrollLock, false);
        if (drag === undefined) return;
        var movement = drag.fingerCurrentY - drag.fingerStartY | 0;
        var nextState = checkWillBeOpen(drag.drawerCurrentY, movement);
        if (isOpen !== nextState) {
            $iv6Yc._1(onChangeState, nextState);
            if (isOpen) {
                if (nextState) ;
                else $iv6Yc.app(trackEvent, [
                    "swipe down drawer",
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                ]);
            } else if (nextState) $iv6Yc._1(onOpen, undefined);
        } else $iv6Yc._1(onChangeState, isOpen);
        $iv6Yc._1(setDrag, function(param) {});
    };
    var fixedPositionCn = $ezf3v.prefix(drag !== undefined || isOpen ? "top-0" : "bottom-0");
    var dragLimit = function dragLimit(y) {
        return $81N94.int_min(topMargin > y ? topMargin : y, windowHeight - collapsedHeight | 0);
    };
    var translateY = drag !== undefined ? dragLimit(drag.drawerCurrentY) : isOpen ? topMargin : (windowHeight - topMargin | 0) - collapsedHeight | 0;
    var style = {
        height: $ezf3v.intToPx(windowHeight - topMargin | 0),
        zIndex: settings.zIndex,
        transform: $ezf3v.translate3d(0, show ? translateY : windowHeight + collapsedHeight | 0, 0)
    };
    var previousCollapsedHeight = $3QSSt.use(collapsedHeight, collapsedHeight);
    var previousWindowHeight = $3QSSt.use(windowHeight, windowHeight);
    var transitionCn = drag === undefined && (previousCollapsedHeight === collapsedHeight || collapsedHeight === 0) && previousWindowHeight === windowHeight && !didEdgeSwipe ? $ezf3v.prefix("transition duration-200 ease-out") : "";
    var stylingCn = $ezf3v.prefix(isOpen || $2whNH.isSome(drag) ? "bg-main text-primary" : "bg-drawer-main text-drawer-label");
    var shadowCn = needsShadow ? "shadow-xl" : "";
    var roundedCn = !needsShadow || isMobilePDP ? "" : "rounded-t-xl rounded-b-none";
    return /*#__PURE__*/ $g85JO.createElement($502134446644a9ce$var$Drawer$Context$Provider, {
        value: {
            needsShadow: needsShadow,
            setNeedsShadow: setNeedsShadow$1
        },
        children: null
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $1TRFX.make([
            $ezf3v.prefix("fixed w-full left-0 bottom-0 bg-main"),
            $ezf3v.prefix("transform"),
            show ? $ezf3v.prefix("translate-y-0") : $ezf3v.prefix("translate-y-full"),
            transitionCn
        ]),
        style: {
            height: $ezf3v.intToPx(collapsedHeight - 26 | 0),
            zIndex: settings.zIndex
        }
    }), /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "smartnav-drawer",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            ref: fwdRef,
            className: $1TRFX.make([
                $ezf3v.prefix("fixed left-0 w-full flex flex-col select-none touch-none overflow-hidden clip-path-bottom-xl"),
                $ezf3v.prefix(shadowCn),
                $ezf3v.prefix(roundedCn),
                fixedPositionCn,
                transitionCn,
                stylingCn,
                className
            ]),
            style: style,
            onTouchEnd: onTouchEnd,
            onTouchMove: onTouchMove,
            onTouchStart: onTouchStart
        }, showDragIndicator && !isMobilePDP ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("w-full flex justify-center p-1.5 h-5 relative z-10")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "rounded-full w-12 h-1 opacity-25",
                isOpen || $2whNH.isSome(drag) ? "bg-primary" : "bg-drawer-label"
            ]))
        })) : null, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("relative flex-grow")
        }, children))
    }));
}
$502134446644a9ce$var$Drawer.displayName = "Drawer";
var $502134446644a9ce$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($502134446644a9ce$var$Drawer);
 /* context Not a pure module */ 
});

parcelRegister("heivG", function(module, exports) {

$parcel$export(module.exports, "SecondaryNavbar", function () { return $c8b21a2fde1093c1$export$98327abcb0b31b81; });
$parcel$export(module.exports, "make", function () { return $c8b21a2fde1093c1$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $6SwLG = parcelRequire("6SwLG");

var $7wIsS = parcelRequire("7wIsS");

var $1xf0g = parcelRequire("1xf0g");

var $lhKg5 = parcelRequire("lhKg5");

var $3sSBX = parcelRequire("3sSBX");

var $dMhWy = parcelRequire("dMhWy");

var $IFWJb = parcelRequire("IFWJb");

var $dAJXq = parcelRequire("dAJXq");

var $2jMpY = parcelRequire("2jMpY");

var $6Ntmr = parcelRequire("6Ntmr");

var $gCzsf = parcelRequire("gCzsf");

var $dJhID = parcelRequire("dJhID");

var $5bEXW = parcelRequire("5bEXW");

var $hBcYV = parcelRequire("hBcYV");

var $5y6Kk = parcelRequire("5y6Kk");

var $dtaxl = parcelRequire("dtaxl");

var $aSJcu = parcelRequire("aSJcu");

var $lBn5n = parcelRequire("lBn5n");

var $g2O4B = parcelRequire("g2O4B");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $4135i = parcelRequire("4135i");

var $lihS4 = parcelRequire("lihS4");

var $5d4w2 = parcelRequire("5d4w2");

var $8E2YL = parcelRequire("8E2YL");

var $jQE31 = parcelRequire("jQE31");

var $gUsPc = parcelRequire("gUsPc");

var $5RX6O = parcelRequire("5RX6O");

var $7jzXU = parcelRequire("7jzXU");
function $c8b21a2fde1093c1$var$Navbar$CheckoutButton(Props) {
    var iconSizeDiffOpt = Props.iconSizeDiff;
    var iconsCustomClassOpt = Props.iconsCustomClass;
    var cartIconPixelAdjustmentsOpt = Props.cartIconPixelAdjustments;
    var theme = Props.theme;
    var icon = Props.icon;
    var classNameOpt = Props.className;
    var iconSizeDiff = iconSizeDiffOpt !== undefined ? iconSizeDiffOpt : 0;
    var iconsCustomClass = iconsCustomClassOpt !== undefined ? iconsCustomClassOpt : "";
    var cartIconPixelAdjustments = cartIconPixelAdjustmentsOpt !== undefined ? cartIconPixelAdjustmentsOpt : "0 0 0 0";
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var match = $8E2YL.use(undefined);
    var settings = match.config.settings;
    var match$1 = $lihS4.useCart(undefined);
    var match$2 = $4135i.useCheckoutAction(undefined);
    var onClick = match$2.onClick;
    var href = match$2.href;
    if (href === undefined && onClick === undefined) return null;
    var tmp = {
        label: "Checkout",
        children: $2whNH.getWithDefault(icon, /*#__PURE__*/ $g85JO.createElement($lhKg5.make, {
            size: 22 + iconSizeDiff | 0
        })),
        show: $2whNH.isSome(settings.checkoutLink),
        openLinkInNewTab: settings.openLinkInNewTab,
        className: $1TRFX.make([
            iconsCustomClass,
            $ezf3v.prefix("ml-auto"),
            className
        ]),
        pixelAdjustments: cartIconPixelAdjustments,
        dataTestId: "navbar-button-checkout",
        badgeDataTestId: "cart-total-count"
    };
    if (onClick !== undefined) tmp.onClick = $loT9g.valFromOption(onClick);
    if (href !== undefined) tmp.href = href;
    var tmp$1 = $2jMpY.fromInt(99, undefined, match$1.cart.itemCount);
    if (tmp$1 !== undefined) tmp.badge = $loT9g.valFromOption(tmp$1);
    if (theme !== undefined) tmp.theme = $loT9g.valFromOption(theme);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative w-12 h-12")
    }, /*#__PURE__*/ $g85JO.createElement($6Ntmr.make, {
        productDirection: /* Bottom */ 1,
        tooltipDirection: /* Left */ 2,
        addedLabel: settings.pdpAddToCartConfirmation,
        className: $ezf3v.prefix("absolute top-0 left-0 w-full h-full")
    }), /*#__PURE__*/ $g85JO.createElement($dAJXq.make, tmp));
}
$c8b21a2fde1093c1$var$Navbar$CheckoutButton.displayName = "Navbar.CheckoutButton";
var $c8b21a2fde1093c1$export$ad9148fd7bde45db = {
    make: $c8b21a2fde1093c1$var$Navbar$CheckoutButton
};
function $c8b21a2fde1093c1$var$Navbar$PrimaryNavbar(Props) {
    var categories = Props.categories;
    var settings = Props.settings;
    var hoveredCategory = Props.hoveredCategory;
    var canLoadHoverMenu = Props.canLoadHoverMenu;
    var drawerState = Props.drawerState;
    var setHoveredCategory = Props.setHoveredCategory;
    var onMouseLeave = Props.onMouseLeave;
    var match = $IFWJb.use(undefined);
    var onMainImageRendered = match.onMainImageRendered;
    var isNavOpen = drawerState === /* Opening */ 1 || drawerState === /* Open */ 2 || !settings.smartbarEnabled;
    var match$1 = $9pMGg.use(undefined);
    var onBackClick = match$1.onBackClick;
    var onCloseNavigation = match$1.onCloseNavigation;
    var onHomeClick = match$1.onHomeClick;
    var match$2 = $aSJcu.use(undefined);
    var isMobileScreen = match$2.isMobile;
    var isUserHoveringCategory = $2whNH.isSome(hoveredCategory);
    var match$3 = $hBcYV.useRouter(undefined);
    var route = match$3.route;
    var match$4;
    if (typeof route === "number") match$4 = [
        false,
        true
    ];
    else switch(route.TAG | 0){
        case /* Home */ 0:
            var match$5 = route._0;
            match$4 = $2whNH.isNone(match$5.filters) && match$5.homeType === /* Index */ 0 ? [
                true,
                false
            ] : [
                false,
                false
            ];
            break;
        case /* ListPage */ 1:
        case /* PDP */ 2:
        case /* QuickView */ 3:
            match$4 = [
                false,
                false
            ];
            break;
    }
    var isNavbarOnly = match$4[1];
    var isHome = match$4[0];
    var isInlineNav = match$1.embedType === /* Inline */ 1;
    var ref = $g85JO.useRef(null);
    var height = $jQE31.usePrimaryNavbarHeightSetter(ref);
    $g2O4B.useNavbarEmptyAlert(categories);
    var sliderWrapperClass = $1TRFX.make([
        isNavOpen ? "swiper-small-navigation" : "swiper-small-navigation--smartbar",
        isMobileScreen ? "swiper-mobile" : "swiper-desktop",
        $ezf3v.prefix("w-0 flex-grow")
    ]);
    var iconSizeDiff = isMobileScreen ? 2 : 0;
    var canRenderBackIcon = settings.backButton && !isMobileScreen && isNavOpen;
    var canRenderHomeAndOpenIcon = !isMobileScreen && !isInlineNav && settings.smartbarEnabled;
    var favorites = $dMhWy.useFavorites(undefined);
    var canRenderFavorites = favorites.source !== /* SourceLocalStorage */ 0 && isInlineNav ? false : !isMobileScreen && isNavOpen && favorites.enabled;
    var canRenderCartIcon = !isMobileScreen && (!isInlineNav || settings.cart) && ($2whNH.isSome(settings.checkoutLink) || settings.cart) && isNavOpen && settings.smartbarEnabled;
    var leftItems = [
        canRenderBackIcon,
        canRenderHomeAndOpenIcon
    ];
    var rightItems = [
        canRenderCartIcon,
        canRenderHomeAndOpenIcon
    ];
    var backIconPixelAdjustments = isMobileScreen ? "0 0 0 -4px" : "0 0 0 0";
    var cartIconPixelAdjustments = isMobileScreen ? "0 -3px 0 0" : "0 0 0 0";
    var forceLabelStyle = !isMobileScreen && !isInlineNav && settings.smartbarEnabled;
    var forceStyle = forceLabelStyle ? /* Labels */ 0 : undefined;
    var onItemMouseEnter = $g85JO.useCallback(function(category) {
        if (drawerState === /* Closed */ 0) return $iv6Yc._1(setHoveredCategory, function(param) {
            return category;
        });
    }, [
        setHoveredCategory,
        drawerState
    ]);
    var onItemRendered = $g85JO.useCallback(function(param) {
        if (isNavbarOnly) return $iv6Yc._1(onMainImageRendered, undefined);
    }, [
        onMainImageRendered
    ]);
    var isRenderingContent = categories.length !== 0 || canRenderBackIcon || canRenderHomeAndOpenIcon || canRenderCartIcon || canRenderFavorites;
    var paddingCn = isInlineNav ? isMobileScreen ? isRenderingContent ? "py-2" : "" : isRenderingContent ? "py-4 px-5" : "" : isMobileScreen || !isRenderingContent ? "" : "py-1 px-5";
    var isMkrBioActive = settings.mkrBio !== undefined;
    var calculateLostWidth = function calculateLostWidth(a, b) {
        var numOfItemsItWillRender = $i7mYY.keep(a, function(a) {
            return a;
        }).length;
        var numOfItemsInOppositeSide = $i7mYY.keep(b, function(b) {
            return b;
        }).length;
        var lostWidthMultiplier = Math.max(0, numOfItemsInOppositeSide - numOfItemsItWillRender | 0);
        return Math.imul(38, lostWidthMultiplier);
    };
    var fullWidth = isMobileScreen && categories.length <= 3 && $2whNH.getWithDefault(forceStyle, settings.categoryLayout) === /* Labels */ 0;
    var match$6 = settings.mkrBio;
    var slidesPerView = match$6 !== undefined && fullWidth ? String(categories.length) : undefined;
    var leftLostWidth = calculateLostWidth(leftItems, rightItems);
    var rightLostWidth = calculateLostWidth(rightItems, leftItems);
    var tmp = {
        categories: categories,
        centered: !isMobileScreen || isMkrBioActive,
        padded: !fullWidth,
        className: sliderWrapperClass,
        dataTestId: "navbar-l1",
        sliderDataTestId: "navbar-l1-container",
        sliderInsetMargin: "0 " + $ezf3v.intToPx(rightLostWidth) + " 0 " + $ezf3v.intToPx(leftLostWidth) + "",
        onItemMouseEnter: onItemMouseEnter,
        onItemClick: match$1.onLauncherItemClick,
        onItemRendered: onItemRendered,
        ariaLabel: "Primary",
        tabIndex: 0,
        theme: settings.smartbarEnabled ? /* Bottombar */ 1 : /* Main */ 0
    };
    if (forceStyle !== undefined) tmp.forceStyle = $loT9g.valFromOption(forceStyle);
    if (slidesPerView !== undefined) tmp.slidesPerView = $loT9g.valFromOption(slidesPerView);
    return /*#__PURE__*/ $g85JO.createElement($dtaxl.make, {
        kind: "menubar",
        fwdRef: $5bEXW.Ref.domRef(ref),
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "relative",
                "left-0",
                "w-full",
                "flex",
                "flex-row",
                "select-none",
                "touch-none",
                "rounded-b-none",
                "z-10",
                "all",
                "hide-on-empty",
                forceLabelStyle ? "h-16" : "",
                isMobileScreen ? "items-stretch" : "items-center",
                isNavOpen ? "bg-main text-secondary" : "bg-drawer-main text-drawer-label",
                paddingCn
            ])),
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: canLoadHoverMenu && isUserHoveringCategory,
            children: $2whNH.mapWithDefault(hoveredCategory, null, function(hoveredCategory) {
                return /*#__PURE__*/ $g85JO.createElement($dJhID.make, {
                    componentName: "NavbarHoverMenu",
                    children: /*#__PURE__*/ $g85JO.createElement($5d4w2.make, {
                        category: hoveredCategory,
                        height: height,
                        key: hoveredCategory.id
                    })
                });
            })
        }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: canRenderBackIcon || canRenderHomeAndOpenIcon,
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("flex space-x-2 pr-4")
            }, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: canRenderBackIcon,
                children: /*#__PURE__*/ $g85JO.createElement($dAJXq.make, {
                    label: "Back",
                    children: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {
                        size: /* Px */ {
                            _0: 26 + iconSizeDiff | 0
                        }
                    }),
                    onClick: function onClick(param) {
                        $iv6Yc._1(onBackClick, undefined);
                    },
                    pixelAdjustments: backIconPixelAdjustments,
                    disabled: isHome && (isInlineNav || !settings.smartbarEnabled),
                    hideOnDisable: isInlineNav,
                    dataTestId: "navbar-button-back"
                })
            }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: canRenderHomeAndOpenIcon,
                children: /*#__PURE__*/ $g85JO.createElement($dAJXq.make, {
                    label: "Home",
                    children: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilEstate.make, {
                        size: /* Px */ {
                            _0: 21
                        },
                        className: $ezf3v.prefix("w-full")
                    }),
                    onClick: function onClick(param) {
                        if (isHome) return;
                        else return $iv6Yc._1(onHomeClick, undefined);
                    },
                    disabled: isHome,
                    dataTestId: "navbar-button-home"
                })
            }))
        }), /*#__PURE__*/ $g85JO.createElement($3sSBX.make, tmp), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: canRenderFavorites || canRenderCartIcon || canRenderHomeAndOpenIcon,
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("ml-auto flex space-x-2 pl-4")
            }, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: canRenderFavorites,
                children: /*#__PURE__*/ $g85JO.createElement($dMhWy.OpenButton.make, {})
            }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: canRenderCartIcon,
                children: /*#__PURE__*/ $g85JO.createElement($c8b21a2fde1093c1$var$Navbar$CheckoutButton, {
                    iconSizeDiff: iconSizeDiff,
                    cartIconPixelAdjustments: cartIconPixelAdjustments
                })
            }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: canRenderHomeAndOpenIcon,
                children: /*#__PURE__*/ $g85JO.createElement($dAJXq.make, {
                    label: isNavOpen ? "Close" : "Open",
                    children: isNavOpen ? /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {
                        size: /* Px */ {
                            _0: 28
                        },
                        className: $ezf3v.prefix("transform rotate-90 cursor-pointer")
                    }) : /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {
                        size: /* Px */ {
                            _0: 28
                        },
                        className: $ezf3v.prefix("transform rotate-90 cursor-pointer")
                    }),
                    onClick: function onClick(param) {
                        if (isNavOpen) return $iv6Yc._1(onCloseNavigation, undefined);
                        else return $iv6Yc._1(onHomeClick, undefined);
                    },
                    dataTestId: "navbar-button-open-close"
                })
            }))
        }))
    });
}
$c8b21a2fde1093c1$var$Navbar$PrimaryNavbar.displayName = "Navbar.PrimaryNavbar";
var $c8b21a2fde1093c1$var$make = /*#__PURE__*/ $g85JO.memo($c8b21a2fde1093c1$var$Navbar$PrimaryNavbar);
var $c8b21a2fde1093c1$export$7904607e15172f6c = {
    make: $c8b21a2fde1093c1$var$make
};
function $c8b21a2fde1093c1$var$useSecondaryNavbarKind(topLevelCategories, activeCategory) {
    $aSJcu.use(undefined);
    var match = $jQE31.Context.use(undefined);
    var activeCategoryId = $2whNH.map(activeCategory, function(c) {
        return c.id;
    });
    var pathDepth = $2whNH.mapWithDefault(activeCategoryId, [], function(id) {
        return $1xf0g.getCategoryPathById(topLevelCategories, id);
    }).length;
    var isForcingPLP = $5RX6O.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */ 1;
    var secondaryCategories = $1xf0g.getSensibleSiblings(true, isForcingPLP, topLevelCategories, activeCategory);
    var secondaryCategories$1 = $i7mYY.keep(secondaryCategories, function(category) {
        return category.visibleInMenuBar;
    });
    var isActiveCategoryLayoutGrid = $2whNH.mapWithDefault(activeCategory, false, function(activeCategory) {
        var match = activeCategory.listPageActiveLayout;
        if (typeof match === "number" || match.TAG !== /* SubCategoriesGrid */ 2) return false;
        else return true;
    });
    var isSubMenuSliderHidden = match.state.subMenuSliderHeight === 0 || $i7mYY.keep(secondaryCategories$1, function(cat) {
        if (cat.visibleInHeaderSlider) return cat.visibleInParent;
        else return false;
    }).length === 0;
    var isSecondaryNavbarVisible = pathDepth > 0 && !isActiveCategoryLayoutGrid || pathDepth > 1 || isForcingPLP;
    var isSecondaryCatActive = $i7mYY.some(secondaryCategories$1, function(cat) {
        return cat.id === $2whNH.getWithDefault(activeCategoryId, "");
    });
    var isFixed = isSecondaryNavbarVisible && isSecondaryCatActive || isForcingPLP || isSubMenuSliderHidden;
    if (isFixed) {
        if (secondaryCategories$1.length !== 0 && isSecondaryNavbarVisible) return {
            TAG: /* Fixed */ 0,
            _0: secondaryCategories$1
        };
        else return;
    } else if (secondaryCategories$1.length !== 0 && isSecondaryNavbarVisible) return {
        TAG: /* Dynamic */ 1,
        _0: secondaryCategories$1
    };
    else return;
}
function $c8b21a2fde1093c1$var$Navbar$SecondaryNavbar$Content(Props) {
    var anchorHookResult = Props.anchorHookResult;
    var kind = Props.kind;
    var match = $9pMGg.use(undefined);
    var onLauncherItemClick = match.onLauncherItemClick;
    $hBcYV.useRouter(undefined);
    var match$1 = $8E2YL.use(undefined).config;
    var settings = match$1.settings;
    var match$2 = $aSJcu.use(undefined);
    var ref = $g85JO.useRef(null);
    var isFixed;
    isFixed = kind.TAG === /* Fixed */ 0 ? true : false;
    $jQE31.useSecondaryNavbarHeightSetter(isFixed, ref);
    var match$3 = $2whNH.getWithDefault(anchorHookResult, $5y6Kk.empty);
    var onAnchorClick = match$3.onClick;
    var onL2ItemClick = function onL2ItemClick(category) {
        var isGoingToAnchor = $iv6Yc._1(onAnchorClick, category);
        if (!isGoingToAnchor) return $iv6Yc._1(onLauncherItemClick, category);
    };
    var key = $i7mYY.map(kind._0, function(category) {
        return category.id;
    }).join("");
    if (kind.TAG === /* Fixed */ 0) return /*#__PURE__*/ $g85JO.createElement($dtaxl.make, {
        kind: "menubar",
        fwdRef: $5bEXW.Ref.domRef(ref),
        children: /*#__PURE__*/ $g85JO.createElement($3sSBX.make, {
            isNested: true,
            categories: kind._0,
            className: $ezf3v.prefix("text-primary pb-2 pt-3"),
            dataTestId: "navbar-l2",
            sliderDataTestId: "navbar-l2-container",
            onItemClick: onLauncherItemClick,
            ariaLabel: "Secondary",
            tabIndex: 0,
            theme: settings.smartbarEnabled ? /* Bottombar */ 1 : /* Main */ 0,
            key: key
        })
    });
    var tmp = {
        autoHide: !match$2.isMobile,
        fwdRef: ref,
        children: /*#__PURE__*/ $g85JO.createElement($3sSBX.make, {
            categories: kind._0,
            className: $ezf3v.prefix("bg-main pb-2 pt-3 text-primary"),
            dataTestId: "navbar-l2",
            sliderDataTestId: "navbar-l2-container",
            onItemClick: onL2ItemClick,
            ariaLabel: "Secondary",
            tabIndex: 0,
            theme: settings.smartbarEnabled ? /* Bottombar */ 1 : /* Main */ 0,
            key: key
        })
    };
    if (match$3.highlightRef !== undefined) tmp.highlightRef = $loT9g.valFromOption(match$3.highlightRef);
    return /*#__PURE__*/ $g85JO.createElement($7jzXU.make, tmp);
}
$c8b21a2fde1093c1$var$Navbar$SecondaryNavbar$Content.displayName = "Navbar.SecondaryNavbar.Content";
var $c8b21a2fde1093c1$var$make$1 = /*#__PURE__*/ $g85JO.memo($c8b21a2fde1093c1$var$Navbar$SecondaryNavbar$Content);
var $c8b21a2fde1093c1$var$Content = {
    make: $c8b21a2fde1093c1$var$make$1
};
function $c8b21a2fde1093c1$var$Navbar$SecondaryNavbar(Props) {
    var anchorHookResult = Props.anchorHookResult;
    var topLevelCategories = Props.topLevelCategories;
    var activeCategory = Props.activeCategory;
    var keepDynamicOpt = Props.keepDynamic;
    var keepFixedOpt = Props.keepFixed;
    var keepDynamic = keepDynamicOpt !== undefined ? keepDynamicOpt : true;
    var keepFixed = keepFixedOpt !== undefined ? keepFixedOpt : true;
    var kind = $c8b21a2fde1093c1$var$useSecondaryNavbarKind(topLevelCategories, activeCategory);
    var kind$1 = kind !== undefined ? kind.TAG === /* Fixed */ 0 ? keepFixed ? kind : undefined : keepDynamic ? kind : undefined : undefined;
    if (kind$1 !== undefined) return /*#__PURE__*/ $g85JO.createElement($c8b21a2fde1093c1$var$make$1, {
        anchorHookResult: anchorHookResult,
        kind: kind$1
    });
    else return null;
}
$c8b21a2fde1093c1$var$Navbar$SecondaryNavbar.displayName = "Navbar.SecondaryNavbar";
var $c8b21a2fde1093c1$var$make$2 = /*#__PURE__*/ $g85JO.memo($c8b21a2fde1093c1$var$Navbar$SecondaryNavbar);
var $c8b21a2fde1093c1$export$98327abcb0b31b81 = {
    useSecondaryNavbarKind: $c8b21a2fde1093c1$var$useSecondaryNavbarKind,
    Content: $c8b21a2fde1093c1$var$Content,
    make: $c8b21a2fde1093c1$var$make$2
};
function $c8b21a2fde1093c1$var$Navbar$NavbarContent(Props) {
    var drawerState = Props.drawerState;
    var activeCategory = Props.activeCategory;
    var topLevelCategories = Props.topLevelCategories;
    var settings = Props.settings;
    var onHoverMenuVisibilityChanged = Props.onHoverMenuVisibilityChanged;
    var match = $aSJcu.use(undefined);
    var match$1 = $9pMGg.use(undefined);
    var match$2 = $6SwLG.Context.use(undefined);
    var setNeedsShadow = match$2.setNeedsShadow;
    $IFWJb.use(undefined);
    var match$3 = $hBcYV.useRouter(undefined);
    var match$4;
    var tmp = match$3.route;
    if (typeof tmp === "number") match$4 = [
        false,
        true
    ];
    else switch(tmp.TAG | 0){
        case /* Home */ 0:
            match$4 = [
                true,
                false
            ];
            break;
        case /* ListPage */ 1:
        case /* PDP */ 2:
        case /* QuickView */ 3:
            match$4 = [
                false,
                false
            ];
            break;
    }
    var match$5 = $jQE31.Context.use(undefined);
    var match$6 = match$5.state;
    var showPrimaryNavbar = match$6.showPrimaryNavbar;
    var isInlineNav = match$1.embedType === /* Inline */ 1;
    var offsetForStickyElements = $gUsPc.useEffective(undefined);
    var offsetForStickyElements$1 = isInlineNav ? offsetForStickyElements : 0;
    var activeCategoryId = $2whNH.map(activeCategory, function(c) {
        return c.id;
    });
    var match$7 = $g85JO.useState(function() {});
    var setHoveredCategory = match$7[1];
    var hoveredCategory = match$7[0];
    var isUserHoveringCategory = hoveredCategory !== undefined;
    var isIndexOrLinkCategory = $2whNH.mapWithDefault(hoveredCategory, false, function(category) {
        if ($1xf0g.isIndexNode(category)) return true;
        else return $1xf0g.isLinkCategory(category);
    });
    var canLoadHoverMenu = activeCategoryId === undefined && !isInlineNav && !match.isMobile && !isIndexOrLinkCategory && match$4[1] && settings.smartbarEnabled;
    $g85JO.useEffect(function() {
        var needsShadow = hoveredCategory === undefined || !canLoadHoverMenu;
        $iv6Yc._1(setNeedsShadow, needsShadow);
    }, [
        hoveredCategory
    ]);
    $g85JO.useEffect(function() {
        $2whNH.forEach(onHoverMenuVisibilityChanged, function(onHoverMenuVisibilityChanged) {
            $iv6Yc._1(onHoverMenuVisibilityChanged, canLoadHoverMenu && isUserHoveringCategory);
        });
    }, [
        onHoverMenuVisibilityChanged,
        isUserHoveringCategory,
        canLoadHoverMenu
    ]);
    var handleSubmenuLeave = $g85JO.useCallback(function($$event) {
        $iv6Yc._1(setHoveredCategory, function(param) {});
    }, [
        setHoveredCategory
    ]);
    var wrapperClassName = isInlineNav ? "sticky" : "sticky left-0 w-full";
    var wrapperStyle = {
        top: showPrimaryNavbar ? $ezf3v.intToPx(offsetForStickyElements$1) : $ezf3v.intToPx(Math.imul(-1, match$6.primaryNavbarHeight) + (0 > offsetForStickyElements$1 ? 0 : offsetForStickyElements$1) | 0),
        transitionProperty: "top"
    };
    var primaryCategories = $g85JO.useMemo(function() {
        return $i7mYY.keep(topLevelCategories, function(category) {
            return category.visibleInMenuBar;
        });
    }, [
        topLevelCategories
    ]);
    var tmp$1 = {
        categories: primaryCategories,
        settings: settings,
        canLoadHoverMenu: canLoadHoverMenu,
        drawerState: drawerState,
        setHoveredCategory: setHoveredCategory,
        onMouseLeave: handleSubmenuLeave
    };
    if (hoveredCategory !== undefined) tmp$1.hoveredCategory = $loT9g.valFromOption(hoveredCategory);
    var primaryNavContent = /*#__PURE__*/ $g85JO.createElement($c8b21a2fde1093c1$var$make, tmp$1);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataActive: showPrimaryNavbar,
        dataTestId: "top-navbar",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "smartnav-navbar",
                wrapperClassName,
                drawerState === /* Opening */ 1 || drawerState === /* Open */ 2 || !settings.smartbarEnabled ? "bg-main" : "bg-drawer-main",
                "transition-top duration-300",
                "flex flex-col z-30"
            ])),
            style: wrapperStyle
        }, primaryNavContent)
    });
}
$c8b21a2fde1093c1$var$Navbar$NavbarContent.displayName = "Navbar.NavbarContent";
var $c8b21a2fde1093c1$export$6175924bb0fd100b = {
    make: $c8b21a2fde1093c1$var$Navbar$NavbarContent
};
function $c8b21a2fde1093c1$var$Navbar(Props) {
    var drawerState = Props.drawerState;
    var embedType = Props.embedType;
    var onHoverMenuVisibilityChanged = Props.onHoverMenuVisibilityChanged;
    var match = $8E2YL.use(undefined).config;
    var topLevelCategories = $lBn5n.useContextualL1s(embedType, drawerState, window.location.pathname);
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, topLevelCategories);
    $aSJcu.use(undefined);
    var tmp = {
        drawerState: drawerState,
        activeCategory: activeCategory,
        topLevelCategories: topLevelCategories,
        settings: match.settings
    };
    if (onHoverMenuVisibilityChanged !== undefined) tmp.onHoverMenuVisibilityChanged = $loT9g.valFromOption(onHoverMenuVisibilityChanged);
    return /*#__PURE__*/ $g85JO.createElement($c8b21a2fde1093c1$var$Navbar$NavbarContent, tmp);
}
$c8b21a2fde1093c1$var$Navbar.displayName = "Navbar";
var $c8b21a2fde1093c1$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($c8b21a2fde1093c1$var$Navbar);
var $c8b21a2fde1093c1$export$aa541d093b11ace2 = $c8b21a2fde1093c1$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("g2O4B", function(module, exports) {

$parcel$export(module.exports, "useNavbarEmptyAlert", function () { return $bae3acbe2b45ac62$export$647e0db4f12e90d4; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $1xf0g = parcelRequire("1xf0g");

var $b5aRK = parcelRequire("b5aRK");

var $hBcYV = parcelRequire("hBcYV");

var $4QdUt = parcelRequire("4QdUt");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
function $bae3acbe2b45ac62$export$647e0db4f12e90d4(navbarCategories) {
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var topLevelCategories = match.categories;
    var configId = match.id;
    var match$1 = $9pMGg.use(undefined);
    var embedType = match$1.embedType;
    var router = $hBcYV.useRouter(undefined);
    var isPreview = $hBcYV.isPreview(router);
    var isNavBeingHiddenWithDisplayNone = $i7mYY.some($i7mYY.map($i7mYY.map(Array.prototype.slice.call(document.querySelectorAll("#maker-smartnav, #maker-smartnav-inline, #maker-smartnav-launcher, #maker-smartnav-section, #maker-smartnav-pdp")), $b5aRK.ofNode), function(node) {
        return $2whNH.map(node, function(node) {
            return window.getComputedStyle(node).display;
        });
    }), function(display) {
        return $7bjme.equal(display, "none");
    });
    $g85JO.useEffect(function() {
        if (!isNavBeingHiddenWithDisplayNone && !isPreview && embedType !== /* Inline */ 1 && navbarCategories.length === 0) {
            var url = window.location.href;
            var categoriesWithLinkThatMatchesUrl = $1xf0g.findCategoriesBy(topLevelCategories, function(cat) {
                return $7bjme.equal($1xf0g.getCategoryLink(cat), url);
            });
            $4QdUt.warning2("Sitewide Nav is rendering an empty navbar", {
                url: url,
                configId: configId,
                feature: "pagenav",
                extraInfo: settings.contextualL1s ? "Page nav is active and these are the categories that have a link that matches the URL:\n" + categoriesWithLinkThatMatchesUrl.map(function(category) {
                    var path = $1xf0g.getCategoryPathById(topLevelCategories, category.id).map(function(cat) {
                        return cat.title;
                    });
                    var pathStr = path.join(" -> ");
                    return '"' + category.title + '"' + (path.length > 1 ? " (" + pathStr + ")" : "") + "";
                }).join(",\n ") + "\n          " : ""
            });
        }
    }, [
        isNavBeingHiddenWithDisplayNone,
        isPreview,
        embedType,
        topLevelCategories.length,
        navbarCategories.length
    ]);
}
 /* react Not a pure module */ 
});

parcelRegister("5d4w2", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $3cb1ab65c13acd79$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $3cb1ab65c13acd79$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("fe7Ke"));
});
function $3cb1ab65c13acd79$var$NavbarHoverMenu_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($3cb1ab65c13acd79$var$component, Props);
}
$3cb1ab65c13acd79$var$NavbarHoverMenu_Lazy.displayName = "NavbarHoverMenu_Lazy";
var $3cb1ab65c13acd79$export$513ccb98c53b8039 = $3cb1ab65c13acd79$var$component.preload;
var $3cb1ab65c13acd79$export$dd44f18ab656f3bb = $3cb1ab65c13acd79$var$NavbarHoverMenu_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("fe7Ke", function(module, exports) {


module.exports = (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("40A3X")).then(function() {
    return parcelRequire("eH1xa");
});

});
parcelRegister("isbc1", function(module, exports) {
"use strict";

var $7J4BA = parcelRequire("7J4BA");
module.exports = $7J4BA(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7J4BA", function(module, exports) {
"use strict";
var $5a004edf52e5b33a$var$cachedBundles = {};
var $5a004edf52e5b33a$var$cachedPreloads = {};
var $5a004edf52e5b33a$var$cachedPrefetches = {};
function $5a004edf52e5b33a$var$getCache(type) {
    switch(type){
        case "preload":
            return $5a004edf52e5b33a$var$cachedPreloads;
        case "prefetch":
            return $5a004edf52e5b33a$var$cachedPrefetches;
        default:
            return $5a004edf52e5b33a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5a004edf52e5b33a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("7wgKE", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $579884101b2e33e1$export$6503ec6e8aabbaf; }, function (v) { return $579884101b2e33e1$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $579884101b2e33e1$export$f7ad0328861e2f03; }, function (v) { return $579884101b2e33e1$export$f7ad0328861e2f03 = v; });
var $579884101b2e33e1$export$6503ec6e8aabbaf;
var $579884101b2e33e1$export$f7ad0328861e2f03;
"use strict";
var $579884101b2e33e1$var$mapping = new Map();
function $579884101b2e33e1$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$579884101b2e33e1$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $579884101b2e33e1$var$resolve(id) {
    var resolved = $579884101b2e33e1$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$579884101b2e33e1$export$6503ec6e8aabbaf = $579884101b2e33e1$var$register;
$579884101b2e33e1$export$f7ad0328861e2f03 = $579884101b2e33e1$var$resolve;

});



parcelRegister("7jzXU", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $553634b2eb218aaa$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $kQxJU = parcelRequire("kQxJU");

var $iXXhl = parcelRequire("iXXhl");

var $5bEXW = parcelRequire("5bEXW");

var $dtaxl = parcelRequire("dtaxl");
function $553634b2eb218aaa$var$LauncherWithAnchorHighlight(Props) {
    var highlightRef = Props.highlightRef;
    var fwdRef = Props.fwdRef;
    var children = Props.children;
    var ref = $g85JO.useRef(null);
    var mergedRef = fwdRef !== undefined ? (0, $iXXhl.default)(ref, fwdRef) : ref;
    var match = $g85JO.useState(function() {});
    var setHighlightedCategoryId = match[1];
    $2whNH.forEach(highlightRef, function(ref) {
        ref.current = function(id) {
            $iv6Yc._1(setHighlightedCategoryId, function(param) {
                return id;
            });
        };
    });
    return /*#__PURE__*/ $g85JO.createElement($dtaxl.make, {
        kind: "menubar",
        fwdRef: $5bEXW.Ref.domRef(mergedRef),
        className: $ezf3v.prefix("w-full relative pointer-events-auto"),
        children: /*#__PURE__*/ $g85JO.createElement($kQxJU.make, {
            props: {
                isNested: true,
                highlightedCategoryId: match[0]
            },
            children: children
        })
    });
}
$553634b2eb218aaa$var$LauncherWithAnchorHighlight.displayName = "LauncherWithAnchorHighlight";
var $553634b2eb218aaa$export$dd44f18ab656f3bb = $553634b2eb218aaa$var$LauncherWithAnchorHighlight;
 /* react Not a pure module */ 
});


parcelRegister("4XxBe", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $39c6bc4b40d3053c$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $kQxJU = parcelRequire("kQxJU");

var $lx43R = parcelRequire("lx43R");
function $39c6bc4b40d3053c$var$HideOnScroll(Props) {
    var enabledOpt = Props.enabled;
    var hideOnOpt = Props.hideOn;
    var scrollableRef = Props.scrollableRef;
    var children = Props.children;
    var threshold = Props.threshold;
    var onChange = Props.onChange;
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var hideOn = hideOnOpt !== undefined ? hideOnOpt : /* Down */ 1;
    var initialDirection = hideOn === /* Up */ 0 ? /* Down */ 1 : /* Up */ 0;
    var scrollElement = $2whNH.flatMap(scrollableRef, function(ref) {
        return $loT9g.nullable_to_opt(ref.current);
    });
    var usingWindow = $2whNH.isNone(scrollElement);
    var match = $lx43R.useScrollable(!usingWindow, scrollElement, initialDirection, threshold, undefined);
    var match$1 = $lx43R.useWindow(usingWindow, undefined, initialDirection, threshold, undefined);
    var scrollDirection = usingWindow ? match$1[0] : match[0];
    var scrollDirection$1 = enabled ? scrollDirection : hideOn;
    $g85JO.useEffect(function() {
        if (enabled) $2whNH.forEach(onChange, function(change) {
            $iv6Yc._1(change, scrollDirection$1 !== hideOn);
        });
    }, [
        scrollDirection$1
    ]);
    return /*#__PURE__*/ $g85JO.createElement($kQxJU.make, {
        props: {
            show: scrollDirection$1 !== hideOn || !enabled
        },
        children: children
    });
}
$39c6bc4b40d3053c$var$HideOnScroll.displayName = "HideOnScroll";
var $39c6bc4b40d3053c$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($39c6bc4b40d3053c$var$HideOnScroll);
 /* make Not a pure module */ 
});

parcelRegister("8Esoa", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $64c8148f42481e6f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $bN6o7 = parcelRequire("bN6o7");

var $hBcYV = parcelRequire("hBcYV");

var $9pMGg = parcelRequire("9pMGg");
function $64c8148f42481e6f$var$EscapeKeyController(Props) {
    var embedType = Props.embedType;
    var match = $hBcYV.useRouter(undefined);
    var route = match.route;
    var match$1 = $9pMGg.use(undefined);
    var onBackClick = match$1.onBackClick;
    var back = function back(param) {
        if (embedType !== 1) {
            if (embedType !== 0) return;
            else return $iv6Yc._1(onBackClick, undefined);
        } else if (typeof route === "number" || route.TAG !== /* Home */ 0) return $iv6Yc._1(onBackClick, undefined);
        else return;
    };
    $bN6o7.use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Escape", back);
    return null;
}
$64c8148f42481e6f$var$EscapeKeyController.displayName = "EscapeKeyController";
var $64c8148f42481e6f$export$dd44f18ab656f3bb = $64c8148f42481e6f$var$EscapeKeyController;
 /* HotKeys-Showside Not a pure module */ 
});
parcelRegister("bN6o7", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $895939d7088e27e5$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $buEet = parcelRequire("buEet");
function $895939d7088e27e5$export$1f96ae73734a86cc(target, metaOpt, ctrlOpt, activeOpt, allowRepeatOpt, preventDefaultOpt, stopPropagationOpt, key, fn) {
    var meta = metaOpt !== undefined ? metaOpt : false;
    var ctrl = ctrlOpt !== undefined ? ctrlOpt : false;
    var active = activeOpt !== undefined ? activeOpt : true;
    var allowRepeat = allowRepeatOpt !== undefined ? allowRepeatOpt : false;
    var preventDefault = preventDefaultOpt !== undefined ? preventDefaultOpt : false;
    var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
    (0, $buEet.default)(key, function(e) {
        if ((allowRepeat || !e.repeat) && (!meta || e.metaKey) && (!ctrl || e.ctrlKey)) {
            $iv6Yc._1(fn, undefined);
            if (preventDefault) e.preventDefault();
            if (stopPropagation) {
                e.stopPropagation();
                return;
            } else return;
        }
    }, {
        eventTypes: [
            "keydown"
        ],
        target: target,
        when: active
    });
}
 /* @rooks/use-key Not a pure module */ 
});
parcelRegister("buEet", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85e1b45adcd4946e$export$2e2bcd8739ae039; });

var $g85JO = parcelRequire("g85JO");
function $85e1b45adcd4946e$var$doesIdentifierMatchKeyboardEvent(e, identifier) {
    if (e.key === identifier || e.code === identifier || e.keyCode === identifier || e.which === identifier || e.charCode === identifier) return true;
    return false;
}
var $85e1b45adcd4946e$var$defaultOptions = {
    when: true,
    eventTypes: [
        "keydown"
    ]
};
/**
 * useKey hook
 *
 * Fires a callback on keyboard events like keyDown, keyPress and keyUp
 *
 * @param {[string|number]} keyList
 * @param {function} callback
 * @param {Options} options
 */ function $85e1b45adcd4946e$var$useKey(input, callback, opts) {
    var keyList = (0, $g85JO.useMemo)(function() {
        if (Array.isArray(input)) return input;
        else return [
            input
        ];
    }, [
        input
    ]);
    var options = Object.assign({}, $85e1b45adcd4946e$var$defaultOptions, opts);
    var when = options.when, eventTypes = options.eventTypes;
    var callbackRef = (0, $g85JO.useRef)(callback);
    var target = options.target;
    (0, $g85JO.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handle = (0, $g85JO.useCallback)(function(e) {
        if (keyList.some(function(identifier) {
            return $85e1b45adcd4946e$var$doesIdentifierMatchKeyboardEvent(e, identifier);
        })) callbackRef.current(e);
    }, [
        keyList
    ]);
    (0, $g85JO.useEffect)(function() {
        if (when && typeof window !== "undefined") {
            var targetNode = target ? target.current : window;
            eventTypes.forEach(function(eventType) {
                targetNode && targetNode.addEventListener(eventType, handle);
            });
            return function() {
                eventTypes.forEach(function(eventType) {
                    targetNode && targetNode.removeEventListener(eventType, handle);
                });
            };
        }
    }, [
        when,
        eventTypes,
        keyList,
        target,
        callback
    ]);
}
var $85e1b45adcd4946e$export$2e2bcd8739ae039 = $85e1b45adcd4946e$var$useKey;

});



parcelRegister("eZ1bL", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $02d0a3dbf2db879c$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $02d0a3dbf2db879c$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("e0MWu"));
});
function $02d0a3dbf2db879c$var$PictureInPicture2_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($02d0a3dbf2db879c$var$component, Props);
}
$02d0a3dbf2db879c$var$PictureInPicture2_Lazy.displayName = "PictureInPicture2_Lazy";
var $02d0a3dbf2db879c$export$513ccb98c53b8039 = $02d0a3dbf2db879c$var$component.preload;
var $02d0a3dbf2db879c$export$dd44f18ab656f3bb = $02d0a3dbf2db879c$var$PictureInPicture2_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("e0MWu", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("lvXsZ")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fsMVk")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("3pqCl")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("f8V71"))
]).then(function() {
    return parcelRequire("kt3tw");
});

});


parcelRegister("h4qog", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $c6d747fc68e9207b$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $dJhID = parcelRequire("dJhID");

var $5bEXW = parcelRequire("5bEXW");

var $hBcYV = parcelRequire("hBcYV");

var $9pMGg = parcelRequire("9pMGg");

var $4YqDw = parcelRequire("4YqDw");

var $8E2YL = parcelRequire("8E2YL");

var $j6rfo = parcelRequire("j6rfo");
function $c6d747fc68e9207b$var$ListPageWithLazyContent(Props) {
    var scrollableContainerRef = Props.scrollableContainerRef;
    var drawerState = Props.drawerState;
    var anchorHookResult = Props.anchorHookResult;
    var listPageContent = Props.listPageContent;
    var children = Props.children;
    var routerProvider = $hBcYV.useRouter(undefined);
    var configurationProvider = $8E2YL.use(undefined);
    var entrypointContext = $9pMGg.use(undefined);
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, configurationProvider.config.categories);
    var innerContainerRef = $g85JO.useRef(null);
    var show;
    if (drawerState !== 0) {
        var tmp = {
            scrollableContainerRef: scrollableContainerRef,
            isSidebarOpen: entrypointContext.isSidebarOpen,
            isMobileFiltersOpen: entrypointContext.isMobileFiltersOpen
        };
        if (activeCategory !== undefined) tmp.activeCategory = $loT9g.valFromOption(activeCategory);
        if (anchorHookResult !== undefined) tmp.anchorHookResult = $loT9g.valFromOption(anchorHookResult);
        show = $2whNH.getWithDefault(listPageContent, /*#__PURE__*/ $g85JO.createElement($4YqDw.make, tmp));
    } else show = null;
    return /*#__PURE__*/ $g85JO.createElement($dJhID.make, {
        componentName: "ListPage",
        redirect: routerProvider.back,
        children: /*#__PURE__*/ $g85JO.createElement($j6rfo.make, {
            useWindow: entrypointContext.embedType === /* Inline */ 1,
            anchorHookResult: anchorHookResult,
            scrollableContainerRef: scrollableContainerRef,
            innerContainerRef: innerContainerRef,
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                ref: $5bEXW.Ref.domRef(innerContainerRef),
                className: $ezf3v.prefix($1TRFX.make([
                    "smartnav-layout",
                    "grid",
                    "bg-main",
                    "relative",
                    "z-0"
                ]))
            }, children, show)
        })
    });
}
$c6d747fc68e9207b$var$ListPageWithLazyContent.displayName = "ListPageWithLazyContent";
var $c6d747fc68e9207b$export$dd44f18ab656f3bb = $c6d747fc68e9207b$var$ListPageWithLazyContent;
 /* react Not a pure module */ 
});
parcelRegister("4YqDw", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $39f16d7306a0a13a$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $39f16d7306a0a13a$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("656hc"));
});
function $39f16d7306a0a13a$var$ListPageContent_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($39f16d7306a0a13a$var$component, Props);
}
$39f16d7306a0a13a$var$ListPageContent_Lazy.displayName = "ListPageContent_Lazy";
var $39f16d7306a0a13a$export$513ccb98c53b8039 = $39f16d7306a0a13a$var$component.preload;
var $39f16d7306a0a13a$export$dd44f18ab656f3bb = $39f16d7306a0a13a$var$ListPageContent_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("656hc", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("gORIA")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fsMVk")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fbQqy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("d773D"))
]).then(function() {
    return parcelRequire("9YpHb");
});

});


parcelRegister("j6rfo", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $de83b69ff86b145c$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $38gYA = parcelRequire("38gYA");

var $hBcYV = parcelRequire("hBcYV");

var $5y6Kk = parcelRequire("5y6Kk");

var $baS9a = parcelRequire("baS9a");

var $93dGk = parcelRequire("93dGk");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $jQE31 = parcelRequire("jQE31");
function $de83b69ff86b145c$var$ListPageScrollableWrapper(Props) {
    var useWindow = Props.useWindow;
    var anchorHookResult = Props.anchorHookResult;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var innerContainerRef = Props.innerContainerRef;
    var children = Props.children;
    var match = $9pMGg.use(undefined);
    var match$1 = $hBcYV.useRouter(undefined);
    var previewMode = match$1.previewMode;
    var match$2 = $8E2YL.use(undefined).config;
    var match$3 = $jQE31.Context.use(undefined);
    var match$4 = match$3.state;
    var match$5 = $2whNH.getWithDefault(anchorHookResult, $5y6Kk.empty);
    var scrollToRef = match$5.scrollToRef;
    var editorLayer = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: $7bjme.notequal(previewMode, /* PreviewLive */ 1) && previewMode !== undefined,
        children: /*#__PURE__*/ $g85JO.createElement($baS9a.make, {
            embedType: match.embedType,
            innerContainerRef: innerContainerRef,
            outerContainerRef: scrollableContainerRef
        })
    });
    if (useWindow) {
        var tmp = {
            children: null,
            onScroll: match$5.onScrollWindow
        };
        if (scrollToRef !== undefined) tmp.scrollToRef = $loT9g.valFromOption(scrollToRef);
        return /*#__PURE__*/ $g85JO.createElement($93dGk.make, tmp, children, editorLayer);
    }
    var tmp$1 = {
        restorationId: "list-page-" + match$2.id,
        onScroll: match$5.onScrollDiv,
        children: null,
        fwdRef: scrollableContainerRef,
        className: $ezf3v.prefix("absolute top-0 left-0 w-full h-full"),
        defaultRestorationPosition: match$4.showPrimaryNavbar ? 0.0 : (match$4.primaryNavbarHeight + match$4.secondaryNavbarHeight | 0) + match$4.toolbarHeight | 0
    };
    if (scrollToRef !== undefined) tmp$1.scrollToRef = $loT9g.valFromOption(scrollToRef);
    return /*#__PURE__*/ $g85JO.createElement($38gYA.make, tmp$1, children, editorLayer);
}
$de83b69ff86b145c$var$ListPageScrollableWrapper.displayName = "ListPageScrollableWrapper";
var $de83b69ff86b145c$export$dd44f18ab656f3bb = $de83b69ff86b145c$var$ListPageScrollableWrapper;
 /* react Not a pure module */ 
});
parcelRegister("baS9a", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $822aa15327520797$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $822aa15327520797$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("b3hRM"));
});
function $822aa15327520797$var$EditorLayer_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($822aa15327520797$var$component, Props);
}
$822aa15327520797$var$EditorLayer_Lazy.displayName = "EditorLayer_Lazy";
var $822aa15327520797$export$dd44f18ab656f3bb = $822aa15327520797$var$EditorLayer_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("b3hRM", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("eqk31")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fgps0"))
]).then(function() {
    return parcelRequire("aPCO3");
});

});


parcelRegister("93dGk", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $696f01cb6e416adf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $kQvlq = parcelRequire("kQvlq");
function $696f01cb6e416adf$var$WindowScrollable(Props) {
    var scrollToRef = Props.scrollToRef;
    var children = Props.children;
    var onScroll = Props.onScroll;
    var match = $kQvlq.useSafeTimeout(undefined, undefined);
    var useScrollToTimeout = match.setTimeout;
    $g85JO.useEffect(function() {
        window.addEventListener("scroll", onScroll, {
            capture: false,
            passive: true,
            once: false
        });
        return function(param) {
            window.removeEventListener("scroll", onScroll, {
                capture: false,
                passive: true
            });
        };
    }, []);
    $2whNH.forEach(scrollToRef, function(scrollTo) {
        scrollTo.current = function(el0) {
            useScrollToTimeout(function(param) {
                var scrollTop;
                scrollTop = typeof el0 === "number" ? 0.0 : el0.TAG === /* Element */ 0 ? el0._0.offsetTop : el0._0;
                var options = {
                    top: scrollTop,
                    left: 0.0,
                    behavior: "smooth"
                };
                window.scrollTo(options);
            }, 0);
        };
    });
    return children;
}
$696f01cb6e416adf$var$WindowScrollable.displayName = "WindowScrollable";
var $696f01cb6e416adf$export$dd44f18ab656f3bb = $696f01cb6e416adf$var$WindowScrollable;
 /* react Not a pure module */ 
});



})();
//# sourceMappingURL=BottombarApp.bs.b22fed25.js.map
